import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';
import { TraceIdService } from '@nagel-utils';
import { Subscription } from 'rxjs';

@Component({
    selector: 'lib-trace-badge',
    standalone: true,
    imports: [MatButtonModule, MatIconModule],
    templateUrl: './trace-badge.component.html',
    styleUrl: './trace-badge.component.scss'
})
export class TraceBadgeComponent implements OnInit, OnDestroy {
    traceId: string | null = null;
    private subscription?: Subscription;

    constructor(
        private traceIdService: TraceIdService,
        private clipboard: Clipboard,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit(): void {
        this.subscription = this.traceIdService.traceId$.subscribe(
            (id) => this.traceId = id
        );
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    copyTraceId(): void {
        if (this.traceId) {
            this.clipboard.copy(this.traceId);
            this.snackBar.open('Trace ID copied to clipboard', '', {
                duration: 2000,
                horizontalPosition: 'center',
                verticalPosition: 'bottom'
            });
        }
    }
}
